/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Currentpage_Loading1Inputs */

const he_extension_popup_currentpage_loading1 = /** @type {(inputs: Extension_Popup_Currentpage_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טוען…`)
};

const en_extension_popup_currentpage_loading1 = /** @type {(inputs: Extension_Popup_Currentpage_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading…`)
};

/**
* | output |
* | --- |
* | "Loading…" |
*
* @param {Extension_Popup_Currentpage_Loading1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_popup_currentpage_loading1 = /** @type {((inputs?: Extension_Popup_Currentpage_Loading1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Currentpage_Loading1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_currentpage_loading1(inputs)
	return en_extension_popup_currentpage_loading1(inputs)
});
export { extension_popup_currentpage_loading1 as "extension_popup_currentPage_loading" }